<template>
  <Responsive v-slot="{ breakpoint }">
    <Highlighter :threshold="500" :offset="0" v-if='breakpoint != "phone"'>
      <slot />
    </Highlighter>
  </Responsive>
  <Responsive v-slot="{ breakpoint }">
    <Highlighter :threshold="300" :offset="0" v-if='breakpoint == "phone"'>
      <slot />
    </Highlighter>
  </Responsive>
</template>
